import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import shadeColor from '../utils/shadeColor';
import arrowWhite from '../utils/images/down_white.png';

const animationTimer = 300;
const easer = 'cubic-bezier(0.4, 0, 0.2, 1)';

const StyledNavigation = styled.nav`
  width: calc(100% - 4.625rem);
  height: 3.5rem;
  margin-left: auto;
  position: fixed;
  top: 0;
  left: 4.625rem;
  background-color: ${props => props.theme.primary};
  z-index: 9;

  @media screen and (max-width: 64rem) {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
  }
`;

const StyledList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;

  @media screen and (max-width: 64rem) {
    flex-direction: column;
  }
`;

const StyledListItem = styled.li`
  display: flex;
  flex: 1;
  justifycontent: center;
  alignitems: center;
  textalign: center;

  @media screen and (max-width: 64rem) {
    display: none;
    width: 100%;
  }

  ${props =>
    props.isActive &&
    !props.navbarOpen &&
    css`
      @media screen and (max-width: 64rem) {
        display: block !important;
      }
    `};

  ${props =>
    props.navbarOpen &&
    css`
      @media screen and (max-width: 64rem) {
        display: block !important;
      }
    `};
`;

const StyledLink = styled.a`
  display: inline-block;
  padding: 1.12rem 2rem;
  color: #ffffff;
  text-decoration: none;
  flex: 1;
  font-family: Source Sans Pro, sans-serif;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 100%;
  }

  @media screen and (max-width: 64rem) {
    display: block;
  }
`;

const DropDownArrow = styled.div`
  position: absolute;
  right: 1.75rem;
  top: 1.15rem;
  cursor: pointer;
  transition: ${animationTimer}ms ${easer};

  @media screen and (min-width: 64rem) {
    display: none;
  }

  img {
    width: 15px;
    transition: ${animationTimer}ms ${easer};

    ${props =>
      props.open &&
      css`
        transform: rotate(180deg);
      `};
  }
`;

export default class SectionNavigation extends Component {
  state = {
    sections: [],
    activeIndex: 0,
    navbarOpen: false // only for mobile
  };

  componentDidMount() {
    if (document && window) {
      this.setState(
        {
          sections: [...document.querySelectorAll('.section')]
            .filter(s => Boolean(s.querySelector('h2')))
            .filter((_, k) => k < 6)
        },
        () => {
          window.addEventListener('scroll', this.scrollListener);
        }
      );
    }
  }

  toggleNavbar = () => {
    const { navbarOpen } = this.state;

    if (window.innerWidth < 1024) {
      this.setState({
        navbarOpen: !navbarOpen
      });
    }
  };

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollListener);
  }

  scrollListener = e => {
    const { sections } = this.state;

    const offset = 70;
    let hasFoundAny = false;

    for (let i = 0; i < sections.length; i++) {
      const elem = sections[i];

      const rect = elem.getBoundingClientRect();
      const yPosMin = rect.y || rect.top;
      const yPosMax = yPosMin + rect.height;

      if (yPosMin - offset < 1 && yPosMax > 0) {
        hasFoundAny = true;

        this.setState({
          activeIndex: i
        });
      }
    }

    if (!hasFoundAny) {
      return false;
    }
  };

  scroll = (elemPos, isEdge, isIE11) => {
    const top =
      typeof window.pageYOffset !== 'undefined'
        ? elemPos + window.pageYOffset - 55
        : elemPos + window.scrollY - 55;

    if (isIE11) {
      document.documentElement.scrollTop = top;
    } else if (isEdge) {
      document.body.scrollTop = top;
    } else {
      window.scroll({
        top,
        left: 0,
        behavior: 'smooth'
      });
    }
  };

  handleScrollTo = (e, s) => {
    const { navbarOpen } = this.state;
    const minWidth = 1024;

    const targetRect = s.getBoundingClientRect();
    const pos = targetRect.y || targetRect.top;
    const isEdge = !targetRect.y;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    if (window && window.innerWidth < minWidth) {
      if (navbarOpen) {
        this.scroll(pos, isEdge, isIE11);
      }

      this.toggleNavbar();
    } else {
      this.scroll(pos, isEdge, isIE11);
    }
  };

  render() {
    const { theme } = this.props;
    const { sections, navbarOpen, activeIndex } = this.state;

    const items = sections.map((s, i) => {
      const label = s.querySelector('h2').innerHTML;
      const strippedLabel = label.replace(/(<([^>]+)>)/gi, '');
      const colorPercentage = parseFloat(`-0.${i}`);
      const isActive = activeIndex === i;

      return (
        <StyledListItem key={i} isActive={isActive} navbarOpen={navbarOpen}>
          <StyledLink
            href={`#${strippedLabel}`}
            style={{
              backgroundColor: shadeColor(theme.secondary, colorPercentage)
            }}
            onClick={e => this.handleScrollTo(e, s)}
          >
            <span style={{ maxWidth: 225 }}>{strippedLabel}</span>
          </StyledLink>
        </StyledListItem>
      );
    });

    return (
      <StyledNavigation>
        <DropDownArrow onClick={this.toggleNavbar} open={navbarOpen}>
          <img src={arrowWhite} alt="" />
        </DropDownArrow>
        <StyledList>{items}</StyledList>
      </StyledNavigation>
    );
  }
}

SectionNavigation.propTypes = {
  theme: PropTypes.shape({
    primary: PropTypes.string.isRequired,
    secondary: PropTypes.string.isRequired,
    tertiary: PropTypes.string.isRequired,
    quarternary: PropTypes.string.isRequired
  })
};



// WEBPACK FOOTER //
// ./src/components/SectionNavigation.js